import Swal from 'sweetalert2';
import './credit-clients.css';
import { FaEdit, FaTimes } from "react-icons/fa";
import axios from 'axios';
import { useEffect, useState } from 'react';

function CreditClients() {
  const URL_ADMIN = process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN || '';
  const [clients, setClients] = useState([]);

  useEffect(() => {
    getClients()
  }, [])

  const getClients = async () => {
    try {
      const response = await axios.get(`${URL_ADMIN}/credit_client`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setClients(response.data.data.credit_clients);
      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: "Error al obtener datos",
        text: "Por favor intenta más tarde"
      });
    }
  }

  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear Cliente",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="client" class="swal2-input" placeholder="Nombre completo">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          const clientName = document.getElementById("client").value.trim();
          if (!clientName) {
            Swal.showValidationMessage("El nombre del cliente no puede estar vacío");
            return false;
          }
          return { name: clientName };
        },
      });

      if (result.isConfirmed) {
        const body = result.value;
        await axios.post(`${URL_ADMIN}/credit_client`, body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        await getClients();
        Swal.fire(
          "¡Creado!",
          "El cliente ha sido creado exitosamente.",
          "success"
        );
      }
      
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: "Error al crear el credito cliente",
        text: "Por favor intenta más tarde"
      });
    }
  }

  const updateClient = async (client) => {

    try {
      const result = await Swal.fire({
        title: "Crear Cliente",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="client" class="swal2-input" placeholder="Nombre completo" value="${client.name || ""}">` +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          const clientName = document.getElementById("client").value.trim();
          if (!clientName) {
            Swal.showValidationMessage("El nombre del cliente no puede estar vacío");
            return false;
          }
          return { name: clientName };
        },
      });
  
      if (result.isConfirmed) {
        const body = result.value;
        await axios.put(`${URL_ADMIN}/credit_client/${client.id}`, body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        await getClients();
        Swal.fire(
          "Actualizado!",
          "El cliente ha sido actualizado correctamente.",
          "success"
        );
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: "Error al actualizar el cliente",
        text: "Por favor intenta más tarde"
      });
    }
  }

  const deleteClient = async (id) => {
    try {

      await axios.delete(`${URL_ADMIN}/credit_client/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      await getClients();
      Swal.fire(
        "Eliminado!",
        "El cliente ha sido eliminado correctamente.",
        "success"
      );
      
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: "Error al eliminar el cliente",
        text: "Por favor intenta más tarde"
      });
    }
  }

  return (
    <>
      <div className='cc-content'>
        <button className='btnn' onClick={createUser}>Crear nuevo</button>
      </div>

      <div className="table-responsive">
        <table className="table table-preve">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Fecha Creación</th>
              <td className="accions">Acciones</td>
            </tr>
          </thead>

          <tbody>
            {clients.map((client, index) => (
              <tr>
                <td>{client.name}</td>
                <td>{client.created_at}</td>
                <td>
                  <FaEdit
                    className="editButton"
                    onClick={() => updateClient(client)}
                  />
                  
                  <FaTimes
                    className="deleteButton"
                    onClick={() => deleteClient(client.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default CreditClients;